import React from 'react';
import { SubscriptionTier, SUBSCRIPTION_TIERS } from '../types/subscription';

interface SubscriptionBadgeProps {
  tier: SubscriptionTier;
  showLabel?: boolean;
  size?: 'small' | 'medium' | 'large';
}

export const SubscriptionBadge: React.FC<SubscriptionBadgeProps> = ({ 
  tier, 
  showLabel = true,
  size = 'medium'
}) => {
  const subscriptionInfo = SUBSCRIPTION_TIERS[tier];
  
  const sizeStyles = {
    small: {
      padding: '0.25rem 0.5rem',
      fontSize: '0.75rem',
      gap: '0.25rem'
    },
    medium: {
      padding: '0.5rem 0.75rem',
      fontSize: '0.875rem',
      gap: '0.5rem'
    },
    large: {
      padding: '0.75rem 1rem',
      fontSize: '1rem',
      gap: '0.75rem'
    }
  };

  const tierColors = {
    free: {
      bg: '#f3f4f6',
      text: '#374151',
      border: '#d1d5db'
    },
    personal: {
      bg: '#dbeafe',
      text: '#1e40af',
      border: '#3b82f6'
    },
    professional: {
      bg: '#fef3c7',
      text: '#92400e',
      border: '#f59e0b'
    }
  };

  const colors = tierColors[tier];
  const styles = sizeStyles[size];

  return (
    <div
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: styles.gap,
        padding: styles.padding,
        backgroundColor: colors.bg,
        color: colors.text,
        border: `1px solid ${colors.border}`,
        borderRadius: '0.5rem',
        fontSize: styles.fontSize,
        fontWeight: '600',
        lineHeight: '1'
      }}
    >
      {tier === 'professional' && (
        <span style={{ fontSize: '1.2em' }}>⭐</span>
      )}
      {tier === 'personal' && (
        <span style={{ fontSize: '1.2em' }}>✨</span>
      )}
      {showLabel && <span>{subscriptionInfo.displayName}</span>}
    </div>
  );
};
